import { render, staticRenderFns } from "./InkasJouIncomeCard.vue?vue&type=template&id=27a2e892&scoped=true&"
import script from "./InkasJouIncomeCard.vue?vue&type=script&lang=js&"
export * from "./InkasJouIncomeCard.vue?vue&type=script&lang=js&"
import style0 from "./InkasJouIncomeCard.vue?vue&type=style&index=0&id=27a2e892&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2e892",
  null
  
)

export default component.exports